import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './meeting-templates.types';
import * as constants from './meeting-templates.constants';

export const meetingTemplatesReducer = generateResourceReducer<types.IMeetingTemplate>({
  STORE: constants.STORE_MEETING_TEMPLATE,
  CLEAR: constants.CLEAR_MEETING_TEMPLATE,
});
